module.exports = __webpack_public_path__ + "img/true.80df14e9.svg";